export const handleScroll = (
  elementId: string,
  block: 'start' | 'end' | 'center' | 'nearest' = 'start',
  inline: 'start' | 'end' | 'center' | 'nearest' = 'end',
) => {
  const element = document.getElementById(elementId);
  element && element.scrollIntoView({ behavior: 'smooth', block: block, inline: inline });
};
